export default __webpack_public_path__ + "static/media/progress-show.077b04f1.svg";